module.exports = __webpack_public_path__ + "img/cisco.8249347a.svg";